export const lmslog = {
    id: "MENU_TEACHER",
    icon: "GiTeacher",
    text: "LMSLogs",
    child: [
      {
        id: "MENU_LMSLOG.LOGS",
        path: "/lmslog/logs",
        isPublic: false,
        text: "Logs",
        child: [],
      },
      {
        id: "MENU_LMSLOG.LOGS",
        path: "/contest/ranking",
        isPublic: false,
        text: "Contest Ranking",
        child: [],
      },
    ],
  };
  